export const getUniqueArray = (array) => {
    return Array.from(new Set(array.map(i1 => JSON.stringify(i1)))).map(i2 => JSON.parse(i2))
}